module.exports = __webpack_public_path__ + "static/media/avatar_2.bbb7b706.png";